import { useCallback } from 'react'
import * as XLSX from 'xlsx'

export const useExport = () => {
  const handleExport = useCallback((data: Array<unknown>) => {
    // Create worksheet from data
    const worksheet = XLSX.utils.json_to_sheet(data)

    // Create workbook and add the worksheet
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, 'DataExport.xlsx')
  }, [])

  return { handleExport }
}
